import { useEffect, useRef } from "react";

export const usePasteFileUpload = (
  handleFileUpload: (e: React.ChangeEvent<HTMLInputElement>) => void,
) => {
  const handlerRef = useRef(handleFileUpload);

  useEffect(() => {
    handlerRef.current = handleFileUpload;
  }, [handleFileUpload]);

  useEffect(() => {
    const handlePaste = (e: ClipboardEvent) => {
      const items = e.clipboardData?.items;
      if (!items) return;

      const fileItem = Array.from(items).find((item) => item.kind === "file");
      if (!fileItem) return;

      e.preventDefault();
      const file = fileItem.getAsFile();
      if (!file) return;

      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(file);

      handlerRef.current({
        target: { files: dataTransfer.files },
      } as React.ChangeEvent<HTMLInputElement>);
    };

    document.addEventListener("paste", handlePaste);
    return () => document.removeEventListener("paste", handlePaste);
  }, []);
};
